
    import React from 'react'
    import Base from '@ucheba/ui/components/Icon'
    import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js"
    import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js"

    const symbol = new SpriteSymbol({
  "id": "icon__help",
  "use": "icon__help-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon__help\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"currentColor\" d=\"M8 1c3.858 0 7 3.142 7 7s-3.142 7-7 7-7-3.142-7-7 3.142-7 7-7zm0 1C4.68 2 2 4.68 2 8s2.68 6 6 6 6-2.68 6-6-2.68-6-6-6zm.25 9v1h-1v-1h1zm.081-6.467c1.129.196 1.945 1.223 1.91 2.36-.027.961-.668 1.675-1.414 2-.27.121-.434.218-.492.281-.054.057-.084.09-.092.242l-.002.086h-1c0-.395.129-.766.367-1.016s.52-.375.817-.507c.476-.21.8-.563.816-1.118.02-.632-.465-1.234-1.078-1.339a1.31 1.31 0 0 0-1.557 1.174l-.006.126h-1c0-1.234.989-2.25 2.2-2.32.171-.008.351.004.531.031z\" /><path d=\"M0 0h16v16H0z\" /></g></symbol>"
})
    sprite.add(symbol)

    export default React.memo(function IconHelpIcon(props) {
      const { className, ...restProps } = props
      return <Base.Icon className={className} id="icon__help" {...restProps} />
    })
  